import ApiInstance from './instance'
import {
  IHmoDTO
} from '@zunta/configurations'

export default class HmoApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  getHmoList (filters: any): Promise<any> {
    return this.instance.doGet('/payments/getHmoList', filters)
  }

  addHmo (hmo: IHmoDTO): Promise<'OK'> {
    return this.instance.doPost('/payments/addHmo', hmo)
  }

  editHmo (hmo: IHmoDTO): Promise<'OK'> {
    return this.instance.doPut('/payments/editHmo', hmo)
  }

  deleteHMO (id: number): Promise<'OK'> {
    return this.instance.doDelete(`/payments/deleteHmo/${id}`)
  }
}
